import { useEffect, useState } from "react";
import { Card, CardBody, CardHeader } from "./../../../../components/card/card.jsx";

import { atmpTrainingMain } from "../../../../config/apiSPA.js";
import SpinnerTable from "../../../../components/spinner/spinnerTable.jsx";
import Pagination3 from "../../../../components/pagination/pagination3.jsx";
import ModalParticipantAtmp from "../modal/modalParticipantAtmp.jsx";
function AtmpTable({ year = "", atmpData = () => {} }) {
  const [search1Value, setSearch1Value] = useState("");
  const [atmpList, setAtmpList] = useState();
  const [modalPart, setModalPart] = useState({ status: false, id: null });
  ////
  const [loadingState, setLoadingState] = useState(true);
  function nextClick1() {
    if (atmpList.meta.current_page < atmpList.meta.last_page) loadData(search1Value, atmpList.meta.current_page + 1, year);
  }
  function prevClick1() {
    if (atmpList.meta.current_page > 0) loadData(search1Value, atmpList.meta.current_page - 1, year);
  }
  function submitSearch1(e) {
    e.preventDefault();
    loadData(search1Value, "", year);
  }

  function checkTanggal(tanggalString) {
    const tanggal = new Date(tanggalString);
    const tahun = tanggal.getFullYear();

    if (tahun < 2000) {
      return "tentative";
    } else {
      return tanggalString;
    }
  }

  function handleClickPesertaModal(val) {
    setModalPart({ status: true, id: val });
  }

  const loadData = async (search = "", page = "", y = "") => {
    setLoadingState(true);
    try {
      const res = await atmpTrainingMain(search, page, y);
      setAtmpList(res);
      atmpData(res);
    } catch (error) {
    } finally {
      setLoadingState(false);
    }
  };
  useEffect(() => {
    loadData("", "", year);
  }, [year]);
  return (
    <>
      <Card>
        <CardBody>
          <div className="mb-sm-4 mb-1 d-sm-flex">
            <div className="mt-sm-0">
              <form onSubmit={(e) => submitSearch1(e)}>
                <div className="input-group">
                  <div className="d-flex justify-content-end">
                    <div className="input-group">
                      <input type="text" onChange={(e) => setSearch1Value(e.target.value)} className="form-control px-35px" placeholder="coba cari : meli" />
                      <div className="input-group-text position-absolute top-0 bottom-0 bg-none border-0 start-0" style={{ zIndex: 1020 }}>
                        <i className="fa fa-search opacity-5"></i>
                      </div>
                    </div>
                  </div>
                  <button className="btn btn-outline-default" type="submit">
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>

          {/* ----------------Table-------------- */}

          <div className="table-responsive">
            <table className="table table-hover text-nowrap">
              <thead>
                <tr>
                  <th className="border-top-0 pt-0 pb-2">Training Title</th>
                  <th className="border-top-0 pt-0 pb-2">Instructor</th>
                  <th className="border-top-0 pt-0 pb-2">Date</th>
                </tr>
              </thead>
              <tbody>
                {loadingState ? (
                  <SpinnerTable colSpan={3} />
                ) : (
                  atmpList.data.map((value, index) => (
                    <tr key={index}>
                      <td className="align-middle">
                        <a href="#/" onClick={() => handleClickPesertaModal(value.atmpMainId)}>
                          {value.kodeTraining.title}
                        </a>
                      </td>
                      <td className="align-middle">{value.instructor.namaInstructor}</td>
                      <td className="align-middle">{checkTanggal(value.startDate)}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>

          {/* ----------------End Table-------------- */}

          {!loadingState ? <Pagination3 pageInfo={atmpList} nextClick={nextClick1} prevClick={prevClick1} /> : ""}
        </CardBody>
      </Card>
      <ModalParticipantAtmp show={modalPart.status} id={modalPart.id} onHide={() => setModalPart((a) => ({ ...a, status: false }))} />
    </>
  );
}

export default AtmpTable;
